<template>
  <v-app>
    <v-toolbar clipped-right clipped-left dense color="white">
      <v-toolbar-title>
        <span style="color:orange">About</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-tooltip bottom color="orange">
          <template v-slot:activator="{on}">
            <v-btn @click="files" v-on="on" flat>
              <v-icon dark color="orange">list</v-icon>
            </v-btn>
          </template>
          <span style="color:white">Files</span>
        </v-tooltip>
        <v-tooltip bottom color="orange">
          <template v-slot:activator="{on}">
            <v-btn @click="score" v-on="on" flat>
              <v-icon dark color="orange">assessment</v-icon>
            </v-btn>
          </template>
          <span style="color:white">Score</span>
        </v-tooltip>
        <v-tooltip bottom color="orange">
          <template v-slot:activator="{on}">
            <v-btn @click="home" v-on="on" flat>
              <v-icon color="orange">home</v-icon>
            </v-btn>
          </template>
          <span style="color:white">Homepage</span>
        </v-tooltip>
      </v-toolbar-items>
    </v-toolbar>
    <v-parallax
      :src="require('@/assets/2.jpg')"
      height="100%"
      style="width: 100%; 
    height: 100%; 
    position: relative; "
    >
      <v-container>
        <v-layout justify-center align-center column>
          <v-flex style="margin-right:5%;margin-left:5%;margin-top:12.5%;margin-bottom:15%;">
            <v-card elevation="24">
              <!-- <v-img
                src="https://firebasestorage.googleapis.com/v0/b/asop-cc502.appspot.com/o/34620941.jpeg?alt=media&token=c8ba409b-2b7a-4be2-abb1-82909dae5cb5"
              >-->
              <v-layout align-center column>
                <v-card-title primary-title>
                  <div>
                    <h3 class="headline" style="color:orange;">UG LPeC</h3>
                  </div>
                </v-card-title>
                <v-layout align-center justify-center column>
                  <v-card-text style="color:orange">Get in touch with our repo / send some feedback using button below</v-card-text>
                </v-layout>
                <v-card-actions>
                  <a href="mailto:uglpec.official@gmail.com" style="color:orange">
                    <v-avatar>
                      <v-icon color="orange" large>email</v-icon>
                    </v-avatar>
                  </a>
                  <div class="mx-2"></div>
                  <a href="https://github.com/uglpec" style="color:orange">
                    <v-avatar size="35">
                      <v-icon color="orange" large>code</v-icon>
                    </v-avatar>
                  </a>
                </v-card-actions>
              </v-layout>
              <!-- </v-img> -->
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-parallax>
  </v-app>
</template>

<script>
import router from "@/router";
export default {
  data() {
    return {};
  },
  methods: {
    home: function() {
      router.push("/portal");
    },
    score: function() {
      router.push("/score");
    },
    files: function() {
      router.push("/files");
    },
    openForm: function() {
      (this.feedback.title = ""),
        (this.feedback.message = ""),
        (this.form = "on");
    }
  }
};
</script>
